    export class ABConst
    {
        static API_VERSION = "api_version";
         static BUNDLE = "bundle";
         static DEVICE_ID = "device_id";
         static LANGUAGE = "language";
         static NETWORK_TYPE = "network_type";
         static OS_TYPE = "os_type";
         static DEVICE_TYPE = "device_type";
         static REQ_ID = "req_id";
         static TARGET_APP_ID = "target_app_id";
         static USER_ID = "user_id";
         static AB_EXPERIMENT_GROUP_ID = "ab_experiment_group_id";
         static AB_EXPERIMENT_ID = "ab_experiment_id";
         static APP_VERSION = "app_version";
         static CAMPAIGN = "campaign";
         static CHANNEL = "channel";
         static COUNTRY = "country";
         static INSTALL_DAYS = "install_days";
         static OS_VERSION = "os_version";
         static TIMESTAMP = "timestamp";
         static H5_HOST_NAME = "h5_host_name";

         static HTTPS = "https://";
         static BASE_NET_ERROR = "BASE_NET_ERROR";
         static ADDRESS = "/service_distribution/distribution/og_ab/uniform/get";
         static ADDRESS_VERSION = "v3.1";
         static ADDRESS_VERSION_WEB = "v3.2";
         static RES_CODE_OK = "200";
         static FAILED_CODE = "-1";
         static NO_CODE_SUC = "NO_CODE_SUC";

         static NO_PARSE_SUC = "NO_PARSE_SUC";
         static PARSE_ERROR = "PARSE_ERROR";
         static CODE = "code";

        static MAX_REQ_COUNT = 100;
        static MAX_RETRY_COUNT = 2;

        //1、func_status：游戏币/玩赚开关，无配置时默认关闭
         static FUNC_STATUS = "func_status";

         static AB_REQ_CONFIG = "ab_req_config"; //SDK向服务器发起抓取配置请求
         static AB_REQ_CONFIG_SUC = "ab_req_config_suc"; //SDK请求配置响应成功
         static AB_REQ_CONFIG_FAIL = "ab_req_config_fail"; //SDK请求配置响应失败
         static AB_REQ_CONFIG_DATA_ERROR = "ab_req_config_data_error"; //SDK请求配置响应成功，但是数据异常（判断状态码为非200时上传）


         static PO_STATE_CHANGE = "po_state_change";//SDK检测到游戏币/玩赚状态从关变为开
         static ENTER_HOME_PAGE = "enter_home_page";//app跳过启动屏进入主界面时



        //SDK判断可以跳过启动屏
         static STARUP_ENTER = "starup_enter";


         static SYS_USER_ID = "sys_user_id";
         static APP_ID = "app_id";
         static SDK_VERSION_CODE = "sdk_version_code";
         static SDK_VERSION_NAME = "sdk_version_name";
         static REQ_ADDR = "req_addr";
         static api_version = "api_version";
         static req_index = "req_index";
         static ETAG = "etag";
         static FROM_ETAG = "from_etag";
         static ab_exp_id = "ab_exp_id";
         static ab_group_id = "ab_group_id";
         static ABTEST = "abtest";
         static CONSUME_TIME = "consume_time";
         static CONFIG_RESULT = "config_result";
         static REQ_INDEX = "req_index"; // 当前请求重试次数
         static ERROR_CODE = "error_code"; // 错误码
         static ERROR_MSG = "error_msg"; // 错误消息
         static RESP_DATA = "resp_data";


         static ENTER_INDEX = "enter_index";
         static USBMODE = "usbmode";
         static DEVMODE = "devmode";
    }
